import React, { useState } from 'react'
import cx from 'classnames'
import { useQuery } from 'react-apollo'

import { RESTAURANTS_FOR_MANAGEMENT_GROUP } from '../../apollo/management-group/management-group.graphql'
import { useOOGlobals } from '../OOGlobalsProvider/OOGlobalsProvider'
import Button from '../Button/Button'
import { Map } from './Map/Map'

import './MultiLocationPage.css'
import { SearchResults } from './SearchResults/SearchResults'

export const MultiLocationPage = () => {
  const [mapVisible, setMapVisible] = useState(false)
  const { managementGroupGuid } = useOOGlobals()
  const { data = {restaurantsForManagementGroup: { restaurants: [] }}, loading } = useQuery(RESTAURANTS_FOR_MANAGEMENT_GROUP, {
    variables: {
      input: { managementGroupGuid }
    }
  })

  const { restaurants } = data.restaurantsForManagementGroup
  return (
    <div styleName={cx('page', {mapVisible})}>
      <section styleName='header'>
        <h1>Find a location near you</h1>
        <div styleName='visibilityToggle'>
          {mapVisible ? (
            <Button style='secondary' onClick={() => setMapVisible(false)}>hide map</Button>
          ) : (
            <Button style='secondary' onClick={() => setMapVisible(true)}>show map</Button>
          )}
        </div>
      </section>
      <section styleName='results'>
        <SearchResults loading={loading} restaurants={restaurants} />
      </section>
      <section styleName={cx('map', { mapVisible })}>
        <Map loading={loading} restaurants={restaurants} />
      </section>
    </div>
  )
}
